import { useAppDispatch } from 'appState/store'
import { useState } from 'react'
import { FaEllipsisH } from 'react-icons/fa'
import { OBDropdown } from '@outbound-ai/ursa'
import styled from 'styled-components'
import { notificator } from 'utils/notificator/notificator'
import { cppuDisableUser, cppuResendInvitation, cppuUpdateOaiUser, keycloakRefresh } from '../userApi'
import { updateCurrentUser } from '../userSlice'
import { UserActivationStatus } from '../utils/UserConstants'
import { CSEditUserModal } from './CSEditUserModal'

export const CSUserGridDropdown = (params?: any) => {
  const dispatch = useAppDispatch()
  const { data } = params
  const [showEditUserModal, setShowEditUserModal] = useState(false)

  const handleEditUser = () => {
    setShowEditUserModal(true)
  }

  const handleDeactivateUser = (status: boolean) => {
    cppuDisableUser(data.userGuid, status)
      .then(() => {
        notificator.notify({
          type: 'success',
          heading: `User ${data.username} ${status ? 'activated' : 'deactivated'} successfully`,
        })
        dispatch(
          updateCurrentUser({
            refresh: true,
          }),
        )
      })
      .catch((error) => {
        const errorMessage = error?.response?.data?.parameters?.[0]?.value
        notificator.notify({
          type: 'error',
          heading: `${errorMessage ? errorMessage : 'Something went wrong'}. Unable to deactivate user`,
        })
      })
  }

  const resendInvitation = () => {
    try {
      cppuResendInvitation(data.username).then(() => {
        notificator.notify({
          type: 'success',
          heading: `Invitation resent to ${data.username}`,
        })
        dispatch(
          updateCurrentUser({
            refresh: true,
          }),
        )
      })
    } catch (error: any) {
      const errorMessage = error?.response?.data?.parameters?.[0]?.value
      notificator.notify({
        type: 'error',
        heading: `${errorMessage ? errorMessage : 'Something went wrong'}. Unable to resend invitation`,
      })
    }
  }

  const refreshKeycloak = () => {
    if (data.userGuid?.length <= 0) {
      notificator.notify({
        type: 'error',
        heading: 'User GUID is not available. Unable to refresh Keycloak.',
      })
      return
    }

    keycloakRefresh(data.userGuid).then(() => {
      notificator.notify({
        type: 'success',
        heading: `Data refreshed for user ${data.username}`,
      })
      dispatch(
        updateCurrentUser({
          refresh: true,
        }),
      )
    })
  }

  const updateUserData = (updatedData: any) => {
    const updateUserData = {
      userGuid: updatedData.userGuid,
      practiceIds: updatedData.practiceIds,
      permissionIds: updatedData.permissionIds,
    }
    cppuUpdateOaiUser(updateUserData)
      .then((res) => {
        notificator.notify({
          type: 'success',
          heading: `User ${res.email} updated successfully`,
        })
        setShowEditUserModal(false)
        dispatch(
          updateCurrentUser({
            refresh: true,
            recentlyModifiedUserGuid: updatedData.userGuid,
            recentlyModifiedUserEmail: updatedData.email,
          }),
        )
      })
      .catch((error) => {
        const errorMessage = error?.response?.data?.parameters?.[0]?.value
        notificator.notify({
          type: 'error',
          heading: `${errorMessage ? errorMessage : 'Something went wrong'}. Unable to update user`,
        })
      })
  }

  return (
    <>
      <Div>
        <OBDropdown
          className="ob-dropdown-container"
          onClick={() => console.log('clicked')}
          variant="tertiary"
          radius="rounded"
          size="small"
          buttonName={<FaEllipsisH />}
          hideCaret={true}
          items={[
            {
              items: [
                {
                  text: 'Edit User',
                  onClick: handleEditUser,
                },
                {
                  text: data.activationStatus === UserActivationStatus.Ok ? 'Deactivate User' : 'Activate User',
                  onClick: () => handleDeactivateUser(data.activationStatus === UserActivationStatus.Ok ? false : true),
                },
                {
                  text: 'Resend Invitation',
                  onClick: () => resendInvitation(),
                  disabled: data.emailVerified,
                },
                {
                  text: 'Refresh user record',
                  onClick: () => refreshKeycloak(),
                },
              ],
            },
          ]}
        />
      </Div>

      {showEditUserModal && (
        <CSEditUserModal
          show={showEditUserModal}
          hide={() => setShowEditUserModal(false)}
          title="Edit User"
          userData={data}
          updateUser={updateUserData}
        />
      )}
    </>
  )
}

const Div = styled.div`
  position: relative;

  .ob-dropdown .dropdown-menu {
    width: 11rem !important;

    position: fixed !important;
    z-index: 9999 !important;
    transform: translateX(-100%) translateX(40px);
  }
  .ob-dropdown .group-item {
    margin-bottom: 0px !important;
  }

  .disabled {
    pointer-events: none;
    opacity: 0.5;
  }
`
